import { useTranslate } from '@refinedev/core';
import { Tooltip, Typography } from 'antd';
import { ProfileOutlined } from '@ant-design/icons';
import { usePublicationDrawer } from './publicationDrawerContext';

interface PublicationDrawerIconProps {
  publicationId: number;
}

/** Icon opening the publication quick-view drawer. Stops propagation so
 * clickable table rows don't navigate as well. */
export const PublicationDrawerIcon = ({
  publicationId,
}: PublicationDrawerIconProps) => {
  const t = useTranslate();
  const { open } = usePublicationDrawer();
  const label = t('user_catalog.publications.drawer.open');

  return (
    <Tooltip title={label}>
      <Typography.Link
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          open(publicationId);
        }}
      >
        <ProfileOutlined />
      </Typography.Link>
    </Tooltip>
  );
};
